import { Box, Divider, Heading } from "@bcc-ui/ui-components";
import React from "react";

import style from "./navigation-header.scss";
import { FeatureBadge } from "components/feature-badge/FeatureBadge";

export interface NavigationHeaderBadge {
    variant: "Beta" | "New";
    href?: string;
    isVisible: boolean;
}

interface Props {
    text: string;
    badge?: NavigationHeaderBadge;
}

export const NavigationHeader = (props: Props) => {
    return (
        <Box columnLayout className={style.navigationHeader}>
            <Box padding="Xs" justifyContent="SpaceBetween">
                <Heading variant="SUBTITLE_1" disableTopSpacing disableBottomSpacing>
                    {props.text}
                </Heading>
                {props.badge?.isVisible && (
                    <FeatureBadge variant={props.badge.variant} href={props.badge.href} isSmall />
                )}
            </Box>
            <Divider direction="Horizontal" />
        </Box>
    );
};
